import InboundManualRequest from '../../server/inboundManualRequest';
import { addLoading, removeLoading } from './loading';

export const getManualRequestOptions = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await InboundManualRequest.getManualRequestOptions();
  } finally {
    dispatch(removeLoading());
  }
};

export const getManualRequestOptionsProducts = (productFilter, loading = true) => async (dispatch) => {
  if (loading) dispatch(addLoading());
  try {
    return await InboundManualRequest.getManualRequestOptionsProducts(productFilter);
  } finally {
    if (loading) dispatch(removeLoading());
  }
};

export const createManualRequest = (newManualRequest) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const inboundManualRequest = await InboundManualRequest.createManualRequest(newManualRequest);
    return inboundManualRequest;
  } finally {
    dispatch(removeLoading());
  }
};
